import React from "react";

/* ── Image imports (replace with your actual files) ── */
import HeroBgImg      from "../../../asset/images/software/hero-bg.webp";
import BcSepIcon      from "../../../asset/images/about/breadcrumb-separator.svg";
import SmartBordersImg from "../../../asset/images/software/smart-borders.webp";
import LaptopDarkImg  from "../../../asset/images/software/laptop-dark.webp";
import CodingScreenImg from "../../../asset/images/software/coding-screens.webp";

/* Certification logos */
import IsoLogo  from "../../../asset/images/software/cert-iso.webp";
import CmmiLogo from "../../../asset/images/software/cert-cmmi.webp";

/* Case Study images */
import CaseImg1 from "../../../asset/images/software/case-traffic.webp";
import CaseImg2 from "../../../asset/images/software/case-ev.webp";
import CaseImg3 from "../../../asset/images/software/case-medical.webp";
import CaseImg4 from "../../../asset/images/software/case-battery.webp";
import CaseImg5 from "../../../asset/images/software/case-manufacturing.webp";
import CaseImg6 from "../../../asset/images/software/case-drivers.webp";

/* Service card icons */
import SvcIcon1  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon2  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon3  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon4  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon5  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon6  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon7  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon8  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon9  from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon10 from "../../../asset/images/software/icon-microcontroller.svg";
import SvcIcon11 from "../../../asset/images/software/icon-microcontroller.svg";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .si { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .si-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    
  }

  .si-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .si-hero-overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.72) 0%,
    //   rgba(0,0,0,0.35) 60%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }

  .si-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .si-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }
 .cr-hero-divider {
    width: 479px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 15px;
  }
  .si-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 160%;
    max-width: 479px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .si-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .si-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .si-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: color 0.15s;
  }

  .si-bc-item:hover { color: #EB2019; }

  .si-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    
    margin: 0 8px;
    flex-shrink: 0;
  }

  .si-bc-sep svg { display: block; }

  .si-bc-item.active { color: #202020; font-weight: 500; }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .si-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     SECTION HEADING (red)
  ══════════════════════════════════════════ */
  .si-section-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 60px;
    line-height: 140%;
  }

  /* ══════════════════════════════════════════
     3. SMART BORDERS
  ══════════════════════════════════════════ */
  .si-smart-section {
    padding: 80px 0 120px 0;
  }

  .si-smart-row {
    display: flex;
    align-items: center;
    gap: 66px;
  }

  .si-smart-left {
       flex: 0 0 617px;
      
      
  }

  .si-smart-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 15px;
    line-height: 120%;
  }

  .si-smart-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  .si-smart-right {
    flex: 0 0 713px;
    max-width: 100%;
  }

  .si-smart-right img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    border-radius: 6px;
    display: block;
  }

  /* ══════════════════════════════════════════
     4. SERVICES PROVIDED
  ══════════════════════════════════════════ */
  .si-services-section {
    padding: 0 0 120px 0;
  }

  .si-services-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    // border: 1px solid #E8E8E8;
  }

  .si-svc-card {
    padding: 30px 30px 56px 30px;
   
    background:#F2F5FA;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 258px;
    border-radius:10px;
  }

  .si-svc-card:nth-child(4n) {
    border-right: none;
  }

  /* Last row — remove bottom border for cards in last row */
  .si-svc-card:nth-last-child(-n+3) {
    border-bottom: none;
  }

  .si-svc-title {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
  }

  .si-svc-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     5. TECHNOLOGIES USED
  ══════════════════════════════════════════ */
  .si-tech-section {
    padding: 0 0 120px 0;
  }

  .si-tech-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    
  }

  .si-tech-card {
    padding: 30px 30px 56px 30px;
    background: #F2F5FA;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 182px;
    border-radius: 10px;
  }

  .si-tech-title {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
  }

  .si-tech-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     6. CERTIFICATIONS
  ══════════════════════════════════════════ */
  .si-cert-section {
    padding: 0 0 120px 0;
  }

  .si-cert-cards {
    display: flex;
    gap: 30px;
  }

  .si-cert-card {
    border: 1px solid #B2B2B2;
    border-radius: 6px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    min-width: 445px;
    // max-width: 240px;
  }

  .si-cert-label {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
  }

  .si-cert-logo {
    height: 177px;
    width: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  /* ══════════════════════════════════════════
     7. CASE STUDIES
  ══════════════════════════════════════════ */
  .si-cases-section {
    padding: 0 0 120px 0;
  }

  .si-cases-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  .si-case-card {
    display: flex;
    flex-direction: column;

    background:#F2F5FA;
    border-radius: 10px;
    overflow: hidden;
    padding:20px 20px 0px 20px;
  }

  .si-case-img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    display: block;
  }

  .si-case-body {
    padding: 30px ;
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
  }

  .si-case-title {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
  }

  .si-case-list {
    list-style: number;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .si-case-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding-left: 8px;
    margin-left:16px;
    position: relative;
  }



  /* ══════════════════════════════════════════
     8. WHY CHOOSE — TOP SECTION
  ══════════════════════════════════════════ */
  .si-why-section {
    padding: 0 0 80px 0;
  }

  .si-why-hero-img {
    width: 100%;
    height: 450px;
    object-fit: cover;
    object-position: center top;
    display: block;
    border-radius: 10px;
    margin-bottom: 60px;
  }

  /* 4 numbered points row */
  .si-points-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
    position: relative;
    padding : 0px 30px;
  }

  /* dashed connector line behind the numbers */
  .si-points-row::before {
    content: '';
    position: absolute;
    top: 40px;
    left: calc(20px + 24px);
    right: calc(20px + 24px);
    height: 1px;
    border-top: 1px dashed #EB2019;
    z-index: 0;
  }

  .si-point {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 20px;
    position: relative;
    z-index: 1;
  }

  .si-point:first-child { padding-left: 0; }
  .si-point:last-child  { padding-right: 0; }

  .si-point-num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background: #FFF0EF;
    border-radius: 10px;
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    flex-shrink: 0;
  }

  .si-point-title {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
  }

  .si-point-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     9. WHY CHOOSE — BOTTOM SPLIT
  ══════════════════════════════════════════ */
  .si-why-bottom {
    padding: 0px 0 120px 0;
  }

  .si-why-bottom-row {
    display: flex;
    align-items: center;
    gap: 66px;
  }

  .si-why-bottom-left {
     flex: 0 0 617px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .si-why-bottom-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    line-height: 120%;
  }

  .si-why-bottom-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #444444;
    line-height: 160%;
  }

  .si-why-bottom-right {
    flex: 0 0 713px;
    max-width: 100%;
  }

  .si-why-bottom-right img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    border-radius: 6px;
    display: block;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .si-hero              { height: 350px; }
    .si-hero-content      { padding: 0 32px; }
    .si-hero-title        { font-size: 30px; }
    .si-breadcrumb-inner  { padding: 0 32px; }
    .si-inner             { padding: 0 32px; }
    .si-smart-section     { padding: 48px 0 48px 0; }
    .si-smart-left {     flex: 0 0 300px;}
    .si-smart-row         { flex-direction:column-reverse; gap: 32px; }
    .si-smart-heading { font-size: 24px; margin-bottom: 20px; }
    .si-smart-right       { flex: 0 0 100px; max-width: 100%; }
    .si-smart-right img   { height: 320px;  width: 700px;  }
     .si-services-section { padding: 0px 0 48px 0; }
      .si-section-heading   { font-size: 24px; margin-bottom: 24px; }
    .si-services-grid     { grid-template-columns: repeat(2, 1fr); }
    .si-svc-card:nth-child(4n)          { border-right: 1px solid #E8E8E8; }
    .si-svc-card:nth-child(2n)          { border-right: none; }
    .si-svc-card:nth-last-child(-n+3)   { border-bottom: 1px solid #E8E8E8; }
    .si-svc-card:nth-last-child(-n+2)   { border-bottom: none; }
    .si-tech-section { padding: 0px 0 48px 0; }
    .si-cert-card {      min-width: 340px;}
    .si-cert-section { padding: 0px 0 48px 0; }

    .si-tech-grid         { grid-template-columns: repeat(2, 1fr); }
    .si-cases-grid        { grid-template-columns: repeat(2, 1fr); }
    .si-cases-section { padding: 0px 0 48px 0; }

    .si-points-row        { grid-template-columns: repeat(2, 1fr); gap: 32px; }
    .si-points-row::before { display: none; }
    .si-point             { padding: 0; }
    .si-why-section { padding: 0px 0 48px 0; }
    .si-why-hero-img {  height: 320px; width:700px; margin-bottom: 24px; }
    .si-why-bottom-left { flex: 0 0 142px;}
    .si-why-bottom-row    { flex-direction: column; gap: 32px; }
    .si-why-bottom-right  { flex: none; max-width: 100%; }
    .si-why-bottom-right img { height: 320px; width:700px; }
    .si-why-bottom-heading { font-size: 24px; }
    .si-why-bottom { padding: 0px 0 48px 0; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .si-hero              { height: 360px; }
    .si-hero-content      { padding: 0 16px; }
    .si-hero-title        { font-size: 24px; margin-bottom: 12px; }
    .cr-hero-divider { width:370px;}
    .si-breadcrumb        { padding: 30px 0 0 0; }
    .si-breadcrumb-inner  { padding: 0 16px; gap:14px;}
    .si-bc-item           { font-size: 14px; gap: 8px; }
    .si-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .si-inner             { padding: 0 16px; }
    
    .si-smart-section     { padding: 60px 0 30px 0; }
    .si-smart-heading     { font-size: 20px; }
    .si-smart-text { font-size: 14px;}
    .si-smart-row {flex-direction: column-reverse;}
    .si-smart-right img   { height: 200px; width:366px; }
   
     .si-services-section { padding: 0px 0 30px 0;}
    .si-services-grid     { grid-template-columns: 1fr; gap: 30px;  }
    .si-svc-card          { border-right: none !important; padding:20px 24px;gap: 15px;     min-height: auto;}
    .si-svc-card:nth-last-child(-n+2) { border-bottom: 1px solid #E8E8E8; }
    .si-svc-title { font-size:16px; }
    .si-svc-desc {font-size:14px; }
    .si-svc-card:last-child { border-bottom: none; }
    .si-tech-card {  padding:20px 24px;gap: 15px;     min-height: auto;}
    .si-tech-grid         { grid-template-columns: 1fr; gap: 15px; }
    .si-tech-title { font-size:16px;}
    .si-tech-desc { font-size:14px;}
    .si-cert-cards        { flex-direction: column; }
    .si-cases-grid        { grid-template-columns: 1fr;     gap: 20px; }
     .si-tech-section { padding: 0px 0 60px 0; }
         .si-cert-card { padding: 11px 0px 28px 25px;}
         .si-cert-logo {     height: 179px; }
     .si-cert-label { font-size:16px;}
     .si-cert-section { padding: 0px 0 60px 0; }
     .si-case-body { padding: 15px 20px 20px 0px; gap: 15px; }
     .si-case-title { font-size:16px;}
     .si-case-list li { font-size:14px;}
     .si-case-img { height: 145px;}
         .si-cases-section { padding: 0px 0 60px 0;}
    .si-points-row        { grid-template-columns:repeat(2, 1fr);   row-gap: 30px; column-gap: 20px;    padding:0px;}
    .si-point-num { width:55px; height:55px;}
    .si-point             { padding: 0 ; width:175px;  gap: 8px;}
    .si-point-title {font-size:14px;}

  
    .si-why-bottom-text {     font-size: 14px;}
       .si-why-section {         padding: 0px 0 60px 0;}
    .si-why-hero-img      { height: 220px; margin-bottom: 40px;width:100%; }
    .si-why-bottom        { padding: 0px 0 60px 0; }
    .si-why-bottom-heading { font-size: 20px; }
        .si-why-bottom-row { gap:20px; flex-direction: column-reverse;}
    .si-section-heading   { font-size: 20px; margin-bottom: 20px; }
        .si-why-bottom-right img { height: 200px; width:366px;}
  }
`;

/* Breadcrumb separator */
const BcArrow = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M2 1l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const services = [
  {
    title: "Hardware Design",
    desc: "Comparative analysis, component selection, BoM listing, schematic preparations, EMI/EMC considerations.",
  },
  {
    title: "Microcontroller Programming",
    desc: "Support for various platforms (e.g., Beaglebone, Nvidia Jetson Nano, etc.) using languages such as C/C++, Python, etc.",
  },
  {
    title: "RTOS (Real-Time Operating System)",
    desc: "Embedded Linux expertise, Yocto build environment, kernel modules, and driver integration.",
  },
  {
    title: "Peripheral Programming & Integration",
    desc: "GPIO, ADCs, HDMI, and serial communication protocols (I2C, SPI, UART, RS485, CAN).",
  },
  {
    title: "Sensor Integration",
    desc: "RFID, temperature sensors, cameras, proximity, and distance sensors.",
  },
  {
    title: "Analysis Tools & Communication Protocols",
    desc: "Wireshark, CAN analyzer, spectrum analyzers, & support for communication protocols (e.g., CAN, Modbus, MQTT).",
  },
  {
    title: "Firmware Development",
    desc: "Specialization in firmware development and hardware design integration.",
  },
  {
    title: "Software Development",
    desc: "Code compilation, build automation, library integration, optimization, multi-processing, debugging, and programming for various architectures.",
  },
  {
    title: "Reporting",
    desc: "Specifications, test reports, and bug tracking.",
  },
  {
    title: "Web Portals & Dashboards",
    desc: "Development of web portals and dashboards for analytics, reporting, and device health monitoring.",
  },
  {
    title: "Automation Testing",
    desc: "Selenium framework and Python-based automation testing.",
  },
];

const technologies = [
  {
    title: "Programming Languages",
    desc: "C, C++, Python, Rust, Java, JavaScript, Assembly.",
  },
  {
    title: "RTOS and Embedded Systems",
    desc: "Embedded Linux, Yocto build environment.",
  },
  {
    title: "Web Development Technologies",
    desc: ".Net framework, JavaScript, HTML/CSS, ReactJS, Bootstrap, C Sharp, Golang, NodeJS, SQL, RESTful APIs, Docker, AWS/Azure DevOps.",
  },
  {
    title: "Analysis and Testing Tools",
    desc: "Wireshark, CAN Analyser, Spectrum Analysers, Selenium Framework.",
  },
  {
    title: "Communication Protocols",
    desc: "CAN, Modbus, Ethernet, TDP, UDP, MQTT.",
  },
];

const certifications = [
  { label: "ISO", logo: IsoLogo, alt: "ISO Certification" },
  { label: "CMMI", logo: CmmiLogo, alt: "CMMI Certification" },
];

const caseStudies = [
  {
    img: CaseImg1,
    title: "Traffic Management",
    items: [
      "SenTec - National Expressway Software For ATMS",
      "Indus - Premises Speed And Incident Capture Software",
      "Symphony Software With Nirvana Hardware - Highway Speed Detection System",
      "ATM8 Morbi - Success Stories",
    ],
  },
  {
    img: CaseImg2,
    title: "EV Segment",
    items: [
      "Quench CMS - Software For Quench EV Chargers",
      "Quench Controller",
      "EV Emulator",
      "Multi Dispenser",
    ],
  },
  {
    img: CaseImg3,
    title: "Medical Field: Software for Dentistry",
    items: ["Flash Ortho Donatie"],
  },
  {
    img: CaseImg4,
    title: "Battery Testing",
    items: ["BTS"],
  },
  {
    img: CaseImg5,
    title: "Manufacturing Industry: Smoke & Heat Segmentation",
    items: ["NishcNi"],
  },
  {
    img: CaseImg6,
    title: "Driver's testing Software",
    items: ["Vehicle Kerb Hit"],
  },
];

const whyPoints = [
  {
    num: "01",
    title: "Proven Track Record",
    desc: "With A Legacy Of Excellence Spanning Decades, We Deliver Trustworthy Results.",
  },
  {
    num: "02",
    title: "Customized Solutions",
    desc: "We Offer Tailored Solutions To Perfectly Align With The Unique Needs Of Every Project.",
  },
  {
    num: "03",
    title: "Commitment To Quality",
    desc: "Excellence Is Ingrained In Every Aspect Of Our Services, From Concept To Execution.",
  },
  {
    num: "04",
    title: "Client-Centric Approach",
    desc: "Your satisfaction is our priority, ensuring a seamless, collaborative experience every step of the way.",
  },
];

export default function SoftwareInnovation() {
  return (
    <div className="si">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="si-hero">
        <img className="si-hero-bg" src={HeroBgImg} alt="Software Innovation Hero" />
        <div className="si-hero-overlay" />
        <div className="si-hero-content">
          <h1 className="si-hero-title">Software Innovation</h1>
          <hr className="cr-hero-divider" />
          <p className="si-hero-subtitle">
            AI Ador Software Innovation Solutions, we are synonymous with cutting-edge technology and software innovation.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="si-breadcrumb" aria-label="Breadcrumb">
        <div className="si-breadcrumb-inner">
          <a href="/" className="si-bc-item">Home</a>
          <span className="si-bc-sep"> <img src={BcSepIcon} alt="" /></span>
          <a href="#" className="si-bc-item">Business</a>
          <span className="si-bc-sep"> <img src={BcSepIcon} alt="" /></span>
          <span className="si-bc-item active">Software Innovation</span>
        </div>
      </nav>

      {/* ══ 3. SMART BORDERS ══ */}
      <section className="si-smart-section">
        <div className="si-inner">
          <div className="si-smart-row">
            <div className="si-smart-left">
              <h2 className="si-smart-heading">Smart Borders</h2>
              <p className="si-smart-text">
                At Ador Software Innovation Solutions, We Are Synonymous With Cutting-Edge Technology And Software Innovation. With Expertise In Software Integration, System Development, And Embedded Technologies, We Specialise In Delivering Professional Solutions Across A Multitude Of Industries. Ador Stands At The Forefront Of Hardware Design Mastery And Technological Proficiency. Our Team Excels In Crafting Multifaceted Hardware Solutions, Leveraging Expertise In Microcontroller Programming, Software Development, And Real-Time Operating Systems. With A Comprehensive Suite Of Services Spanning From Hardware Design To Firmware Development, We Empower Projects With Reliability, Performance, And Seamless Connectivity.
              </p>
            </div>
            <div className="si-smart-right">
              <img src={SmartBordersImg} alt="Smart Borders" />
            </div>
          </div>
        </div>
      </section>

      {/* ══ 4. SERVICES PROVIDED ══ */}
      <section className="si-services-section">
        <div className="si-inner">
          <h2 className="si-section-heading">Services Provided</h2>
          <div className="si-services-grid">
            {services.map((svc, idx) => (
              <div className="si-svc-card" key={idx}>
                <p className="si-svc-title">{svc.title}</p>
                <p className="si-svc-desc">{svc.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 5. TECHNOLOGIES USED ══ */}
      <section className="si-tech-section">
        <div className="si-inner">
          <h2 className="si-section-heading">Technologies Used</h2>
          <div className="si-tech-grid">
            {technologies.map((tech, idx) => (
              <div className="si-tech-card" key={idx}>
                <p className="si-tech-title">{tech.title}</p>
                <p className="si-tech-desc">{tech.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 6. CERTIFICATIONS ══ */}
      <section className="si-cert-section">
        <div className="si-inner">
          <h2 className="si-section-heading">Certifications</h2>
          <div className="si-cert-cards">
            {certifications.map((cert, idx) => (
              <div className="si-cert-card" key={idx}>
                <span className="si-cert-label">{cert.label}</span>
                <img className="si-cert-logo" src={cert.logo} alt={cert.alt} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 7. CASE STUDIES ══ */}
      <section className="si-cases-section">
        <div className="si-inner">
          <h2 className="si-section-heading">Case Studies</h2>
          <div className="si-cases-grid">
            {caseStudies.map((cs, idx) => (
              <div className="si-case-card" key={idx}>
                <img className="si-case-img" src={cs.img} alt={cs.title} />
                <div className="si-case-body">
                  <p className="si-case-title">{cs.title}</p>
                  <ul className="si-case-list">
                    {cs.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 8. WHY CHOOSE — HERO IMG + 4 POINTS ══ */}
      <section className="si-why-section">
        <div className="si-inner">
          <h2 className="si-section-heading">Why Choose Ador Software Innovation</h2>
          <img
            className="si-why-hero-img"
            src={LaptopDarkImg}
            alt="Why Choose Ador Software Innovation"
          />
          <div className="si-points-row">
            {whyPoints.map((pt, idx) => (
              <div className="si-point" key={idx}>
                <span className="si-point-num">{pt.num}</span>
                <p className="si-point-title">{pt.title}</p>
                <p className="si-point-desc">{pt.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 9. WHY CHOOSE — BOTTOM SPLIT ══ */}
      <section className="si-why-bottom">
        <div className="si-inner">
          <div className="si-why-bottom-row">
            <div className="si-why-bottom-left">
              <h2 className="si-why-bottom-heading">Why Choose Ador Software Innovation</h2>
              <p className="si-why-bottom-text">
                Discover The Difference Of Working With A Company Passionate About Innovation, Reliability, And Exceeding Expectations. Contact Us Now To Explore How Our Comprehensive Suite Of Services Can Propel Your Projects To New Heights. Let's Shape The Future Together With Ador Group.
              </p>
            </div>
            <div className="si-why-bottom-right">
              <img src={CodingScreenImg} alt="Coding Screens" />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}